import * as yup from "yup";
import { notMaterial } from "../../constants";
import { FormDropdownOption } from "../FormDropdown";
import { EditMonthlyEstimatesFormValues } from "../EditMonthlyEstimates/EditMonthlyEstimatesFormValues";

export type CreateEmissionsSourceFormValues = {
    name: string;
    uniqueReference: string;
    locationId: number;
    categoryId: number;
    typeId: number;
    itemId: number;
    isMaterial: number;
    dataStatusId: number;
    justification: string;
    requiredEvidenceTypeIds: Pick<
        FormDropdownOption<number>,
        "value" | "label"
    >[];
} & EditMonthlyEstimatesFormValues;

export const buildStep1ValidationFields = (
    uniqueReferenceIsUnique: (uniqueReference: string) => Promise<boolean>
) => ({
    name: yup.string().required("Please enter a data source name"),
    uniqueReference: yup
        .string()
        .required("Please enter a data source unique reference")
        .test(
            "uniqueReference",
            "This unique reference is already being used.",
            async (value) => {
                if (!value) return true;
                return await uniqueReferenceIsUnique(value);
            }
        ),
    locationId: yup.number().required().moreThan(0, "Please select a location"),
});

export const buildStep2ValidationFields = () => ({
    categoryId: yup.number().required().moreThan(0, "Please select a category"),
    typeId: yup.number().required().moreThan(0, "Please select a type"),
    itemId: yup.number().required().moreThan(0, "Please select an item"),
    isMaterial: yup.number().required().moreThan(0),
    justification: yup
        .string()
        .ensure()
        .when("isMaterial", {
            is: notMaterial,
            then: yup.string().required("Please enter a justification"),
        }),
});

export const step3ValidationFields = {
    dataStatusId: yup
        .number()
        .required("Please select a data status")
        .moreThan(0, "Please select a data status"),
    justification: yup
        .string()
        .ensure()
        .when("dataStatusId", {
            is: (value: number) => value > 0,
            then: yup.string().required("Please enter a justification"),
        }),
    requiredEvidenceTypeIds: yup.array().of(
        yup.object().shape({
            value: yup.number().required(),
            label: yup.string().required(),
        })
    ),
    januaryEstimatedKgCO2e: yup.number(),
    februaryEstimatedKgCO2e: yup.number(),
    marchEstimatedKgCO2e: yup.number(),
    aprilEstimatedKgCO2e: yup.number(),
    mayEstimatedKgCO2e: yup.number(),
    juneEstimatedKgCO2e: yup.number(),
    julyEstimatedKgCO2e: yup.number(),
    augustEstimatedKgCO2e: yup.number(),
    septemberEstimatedKgCO2e: yup.number(),
    octoberEstimatedKgCO2e: yup.number(),
    novemberEstimatedKgCO2e: yup.number(),
    decemberEstimatedKgCO2e: yup.number(),
};

export const defaultValues: CreateEmissionsSourceFormValues = {
    name: "",
    uniqueReference: "",
    locationId: -1,
    categoryId: -1,
    typeId: -1,
    itemId: -1,
    isMaterial: 1,
    dataStatusId: -1,
    requiredEvidenceTypeIds: [],
    justification: "",
};
